import filmMiddleware from './filmMiddleware';

// eslint-disable-next-line
export default [
    filmMiddleware,
];